import {
  useGetRecordingQuery,
  useGetWorkspaceQuery,
  useLazyGetFolderQuery,
} from '@carboncopyco/data';
import { Breadcrumbs } from '@carboncopyco/ui';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useClonePageProps } from './ClonePageContext';

export const ClonePageBreadcrumbs = () => {
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { organizationId, cloneId } = useClonePageProps();
  const { data: workspace } = useGetWorkspaceQuery({
    organizationId: organizationId,
    id: workspaceId,
  });
  const { data: clone } = useGetRecordingQuery({
    organizationId,
    id: cloneId,
  });
  const [getFolder, { data: folder }] = useLazyGetFolderQuery();

  const links = useMemo(
    () => [
      {
        label: workspace?.workspaceName,
        onClick: () => navigate(`/${organizationId}/workspace/${workspaceId}`),
      },
    ],
    [navigate, organizationId, workspace?.workspaceName, workspaceId]
  );

  useEffect(() => {
    if (clone?.folderId) {
      getFolder({
        organizationId,
        workspaceId,
        folderId: String(clone.folderId),
      });
    }
  }, [clone, workspaceId, getFolder, organizationId]);

  const getDemoPageLinks = useMemo(() => {
    if (folder && clone.folderId) {
      return [
        ...links,
        {
          label: folder?.name,
          onClick: () =>
            navigate(
              `/${organizationId}/workspace/${workspaceId}/folder/${clone.folderId}`
            ),
        },
      ];
    }
    return links;
  }, [folder, clone?.folderId, links, navigate, organizationId, workspaceId]);

  return (
    <Breadcrumbs
      current={clone?.recordName}
      links={getDemoPageLinks}
    />
  );
};
